import TextButton from '@oberoninternal/travelbase-ds/components/action/TextButton';
import Cross from '@oberoninternal/travelbase-ds/components/figure/Cross';
import { Edit } from '@oberoninternal/travelbase-ds/components/figure/Edit';
import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import { Box, Flex } from '@rebass/grid';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import euroFormat from '../../constants/euroFormat';
import { CompanyRateGroupFragment } from '../../generated/graphql';
import getPeriodText from '../../utils/getPeriodText';
import TableActions from '../atoms/TableActions';
import TableRowSeperator from '../atoms/TableRowSeperator';
import { getHeaderTexts } from '../pages/company/Rates';

interface Props {
    rateGroup: CompanyRateGroupFragment;
    handleRemove: (rateGroupId: string) => Promise<void>;
    handleEdit: (rateGroup: CompanyRateGroupFragment) => void;
}

const CompanyRateGroupRow: FC<React.PropsWithChildren<Props>> = ({ rateGroup, handleRemove, handleEdit }) => {
    const { id, rates, startDate, endDate, canBuyTickets } = rateGroup;
    const intl = useIntl();
    const periodText = getPeriodText(startDate, endDate, intl);
    const headerTexts = getHeaderTexts(intl);
    return (
        <>
            <tr>
                <td data-label={headerTexts.period}>{periodText}</td>
                <td data-label={headerTexts.sellsTickets}>
                    {canBuyTickets ? (
                        <FormattedMessage defaultMessage="Ja" />
                    ) : (
                        <FormattedMessage defaultMessage="Nee" />
                    )}
                </td>
                <td data-label={headerTexts.price}>
                    {rates.map(rate => (
                        <Flex mb={[3, null, 4]} key={rate.id}>
                            <Box width="20rem">
                                <Body>{rate.name}</Body>
                            </Box>
                            <Box>
                                <Body>{euroFormat(rate.price)}</Body>
                            </Box>
                        </Flex>
                    ))}
                </td>
                <td data-label={headerTexts.actions}>
                    <TableActions>
                        <TextButton onClick={() => handleEdit(rateGroup)} size="tiny">
                            <Edit />
                            <span>
                                <FormattedMessage defaultMessage="Aanpassen" />
                            </span>
                        </TextButton>
                        <TextButton
                            onClick={() => {
                                if (
                                    !window.confirm(
                                        `Weet je zeker dat je deze tariefgroep (${periodText}) wilt verwijderen?`
                                    )
                                ) {
                                    return;
                                }
                                handleRemove(id);
                            }}
                            variant="danger"
                            size="tiny"
                        >
                            <Cross />
                            <span>
                                <FormattedMessage defaultMessage="Verwijderen" />
                            </span>
                        </TextButton>
                    </TableActions>
                </td>
            </tr>
            <tr>
                <td colSpan={4}>
                    <TableRowSeperator />
                </td>
            </tr>
        </>
    );
};

export default CompanyRateGroupRow;
